import mock from 'src/utils/mock';
import { getEnvVars } from 'src/config/env.config';

function InitMockRunner() {
  const { ENV } = getEnvVars();

  if (ENV !== 'local') {
    mockRunner();
  }
}

function mockRunner() {
  const { subjectMockInit } = require('.');
  subjectMockInit(mock);
}

export { InitMockRunner };
